import React from 'react'
import { ArrowBlue, CircularAdd } from '../../assets/icons'
import { ListItem } from '../atoms/builder-2.0/ListItem'
import { StyleSheet } from 'react-native'
import { useTranslation } from 'react-i18next'
import AddPaymentMethodStore from '../../store/AddPaymentMethodStore'

export const AddNewButton = () => {
  const { t } = useTranslation('global')
  const { setModal } = AddPaymentMethodStore
  return (
    <ListItem
      icon={<CircularAdd />}
      style={styles.listItem}
      title={t('InvoiceDetails.add-new-payment-method')}
      endIcon={<ArrowBlue style={{ height: 26, width: 26 }} />}
      onPress={() => setModal('addPaymentMethod', true)}
      otherStyles={{
        title: {
          lineHeight: 20,
          fontWeight: '600',
          marginBottom: 2,
        },
        frontIcon: { marginTop: 14, width: 40, height: 40 },
      }}
    />
  )
}

const styles = StyleSheet.create({
  listItem: {
    borderWidth: 1,
    borderColor: '#CCD6DD',
    height: 72,
    borderRadius: 8,
  },
})
